import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { EstadoDeCuentaService } from "./estado-de-cuenta.service";
import { ClienteLogin, ClienteXCiudad } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { DatosGeneralesEntity } from "../entities/datos_generales_entity";
import { EstadosDeCuentaCliente, EstadoDeCuentaPorSegmento, EstadoDeCuentaGlobal } from "../entities/estado_de_cuenta_entity";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";


const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'estadoDeCuenta',
    providers: [EstadoDeCuentaService],
    templateUrl: 'estado-de-cuenta.template.html'

})

export class EstadoDeCuenta implements OnInit {
    public estadosDeCuentaCliente: EstadosDeCuentaCliente;
    usuario: ClienteLogin;
    showLoader: string;
    sumaPatrimonialPrima: number;
    sumaPatrimonialMas30: number;
    sumaPatrimonialDe0a7: number;
    sumaPatrimonialDe8A15: number;
    sumaPatrimonialDe16A30: number;
    sumaFianzaPymesPrima: number;
    sumaFianzaPymesMas30: number;
    sumaFianzaPymesDe0a7: number;
    sumaFianzaPymesDe8A15: number;
    sumaFianzaPymesDe16A30: number;
    sumaVidaAsistenciaPrima: number;
    sumaVidaAsistenciaMas30: number;
    sumaVidaAsistenciaDe0a7: number;
    sumaVidaAsistenciaDe8A15: number;
    sumaVidaAsistenciaDe16A30: number;
    modalEstadoDeCuenta: EstadoDeCuentaPorSegmento;
    modalListaFacturas: EstadoDeCuentaGlobal[];
    public filterQuery = "";
    diasBandera:number;

    sumaPatrimonialDias: number;
    sumaFianzaPymesDias: number;
    sumaVidaAsistenciaDias: number;

    modalPrima: number;
    modalMas30: number;
    modalDe0a7: number;
    modalDe8a15: number;
    modalDe16a30: number;
    modalDias: number;

    sumaTotal: number;

    public patrimonial: boolean;
    public fianzasPymes: boolean;
    public vidaAsistencia: boolean;

    @ViewChild('facturaEstadoDeCuenta')
    modal: ModalComponent;

    constructor(private estadoDeCuentaService: EstadoDeCuentaService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService) {
        this.estadosDeCuentaCliente = new EstadosDeCuentaCliente();
        this.estadosDeCuentaCliente.EstadoDeCuentaPatrimonial = new EstadoDeCuentaPorSegmento();
        this.estadosDeCuentaCliente.EstadoDeCuentaFianzasPymes = new EstadoDeCuentaPorSegmento();
        this.estadosDeCuentaCliente.EstadoDeCuentaVidaAsistencia = new EstadoDeCuentaPorSegmento();
        this.estadosDeCuentaCliente.EstadoDeCuentaPatrimonialXRamo = new Array<EstadoDeCuentaPorSegmento>();
        this.estadosDeCuentaCliente.EstadoDeCuentaFianzasPymesXRamo = new Array<EstadoDeCuentaPorSegmento>();
        this.estadosDeCuentaCliente.EstadoDeCuentaVidaAsistenciaXRamo = new Array<EstadoDeCuentaPorSegmento>();
        this.estadosDeCuentaCliente.EstadoDeCuentaXFactura = new Array<EstadoDeCuentaGlobal>();
        this.sumaPatrimonialPrima = 0;
        this.sumaPatrimonialMas30 = 0;
        this.sumaPatrimonialDe0a7 = 0;
        this.sumaPatrimonialDe8A15 = 0;
        this.sumaPatrimonialDe16A30 = 0;
        this.sumaPatrimonialDias = 0;
        this.sumaFianzaPymesPrima = 0;
        this.sumaFianzaPymesMas30 = 0;
        this.sumaFianzaPymesDe0a7 = 0;
        this.sumaFianzaPymesDe8A15 = 0;
        this.sumaFianzaPymesDe16A30 = 0;
        this.sumaFianzaPymesDias = 0;
        this.sumaVidaAsistenciaPrima = 0;
        this.sumaVidaAsistenciaMas30 = 0;
        this.sumaVidaAsistenciaDe0a7 = 0;
        this.sumaVidaAsistenciaDe8A15 = 0;
        this.sumaVidaAsistenciaDe16A30 = 0;
        this.sumaVidaAsistenciaDias = 0;
        this.modalPrima = 0;
        this.modalDe0a7 = 0;
        this.modalDe8a15 = 0;
        this.modalDe16a30 = 0;
        this.modalMas30 = 0;
        this.modalDias = 0;

        this.sumaTotal = 0;
        this.patrimonial = true;
        this.fianzasPymes = true;
        this.vidaAsistencia = true;

    }

    ngOnInit() {
        this.showLoader = "sk-loading";
        try {
            this.estadosDeCuentaCliente = new EstadosDeCuentaCliente();
            this.estadosDeCuentaCliente.EstadoDeCuentaPatrimonial = new EstadoDeCuentaPorSegmento();
            this.estadosDeCuentaCliente.EstadoDeCuentaFianzasPymes = new EstadoDeCuentaPorSegmento();
            this.estadosDeCuentaCliente.EstadoDeCuentaVidaAsistencia = new EstadoDeCuentaPorSegmento();
            this.estadosDeCuentaCliente.EstadoDeCuentaPatrimonialXRamo = new Array<EstadoDeCuentaPorSegmento>();
            this.estadosDeCuentaCliente.EstadoDeCuentaFianzasPymesXRamo = new Array<EstadoDeCuentaPorSegmento>();
            this.estadosDeCuentaCliente.EstadoDeCuentaVidaAsistenciaXRamo = new Array<EstadoDeCuentaPorSegmento>();
            this.estadosDeCuentaCliente.EstadoDeCuentaXFactura = new Array<EstadoDeCuentaGlobal>();
            /*correctHeight();
            detectBody();*/
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            if (this.usuario == null) {
                let error = { "status": 998, "message": "Acceso denegado" };
                this.handleError.redirectUrl(error)
            } else {
                let bandera = this.sessionTokenService.useJwtHelper();
                if (!bandera) {
                    this.estadoDeCuentaService.consultaEstadoDeCuenta().subscribe(a => {
                        this.estadosDeCuentaCliente = a;
                        this.estadosDeCuentaCliente.EstadoDeCuentaPatrimonialXRamo.forEach(a => {
                            this.sumaPatrimonialPrima += a.Prima;
                            this.sumaPatrimonialMas30 += a.Mas30;
                            this.sumaPatrimonialDe0a7 += a.De0A7;
                            this.sumaPatrimonialDe8A15 += a.De8A15;
                            this.sumaPatrimonialDe16A30 += a.De16A30;
                            this.sumaPatrimonialDias += a.Dias;
                        });
                        this.estadosDeCuentaCliente.EstadoDeCuentaFianzasPymesXRamo.forEach(a => {
                            this.sumaFianzaPymesPrima += a.Prima;
                            this.sumaFianzaPymesMas30 += a.Mas30;
                            this.sumaFianzaPymesDe0a7 += a.De0A7;
                            this.sumaFianzaPymesDe8A15 += a.De8A15;
                            this.sumaFianzaPymesDe16A30 += a.De16A30;
                            this.sumaFianzaPymesDias += a.Dias;
                        });
                        this.estadosDeCuentaCliente.EstadoDeCuentaVidaAsistenciaXRamo.forEach(a => {
                            this.sumaVidaAsistenciaPrima += a.Prima;
                            this.sumaVidaAsistenciaMas30 += a.Mas30;
                            this.sumaVidaAsistenciaDe0a7 += a.De0A7;
                            this.sumaVidaAsistenciaDe8A15 += a.De8A15;
                            this.sumaVidaAsistenciaDe16A30 += a.De16A30;
                            this.sumaVidaAsistenciaDias += a.Dias;
                        });
                        let primaPatrimonial = 0;
                        let primaFianzasPymes = 0;
                        let primaVidaAsistencia = 0;
                        if (this.estadosDeCuentaCliente.EstadoDeCuentaPatrimonial != null) {
                            primaPatrimonial = this.estadosDeCuentaCliente.EstadoDeCuentaPatrimonial.Prima;
                        }
                        if (this.estadosDeCuentaCliente.EstadoDeCuentaFianzasPymes != null) {
                            primaPatrimonial = this.estadosDeCuentaCliente.EstadoDeCuentaFianzasPymes.Prima;
                        }
                        if (this.estadosDeCuentaCliente.EstadoDeCuentaVidaAsistencia != null) {
                            primaPatrimonial = this.estadosDeCuentaCliente.EstadoDeCuentaVidaAsistencia.Prima;
                        }
                        this.sumaTotal = primaPatrimonial + primaFianzasPymes + primaVidaAsistencia;
                        this.showLoader = "";
                    }, error => { this.handleError.redirectUrl(error); });
                }
            }
        } catch (ex) {
            let error = { "status": 500, "message": "" };
            this.handleError.redirectUrl(error)
        }
    }

    modalClose() {
        this.modal.close();
    }
    modalOpen(e) {
        this.modalPrima = 0;
        this.modalMas30 = 0;
        this.modalDe0a7 = 0;
        this.modalDe8a15 = 0;
        this.modalDe16a30 = 0;
        this.modalDias = 0;
        this.filterQuery = "";
        this.modalListaFacturas = new Array<EstadoDeCuentaGlobal>();
        this.modalEstadoDeCuenta = new EstadoDeCuentaPorSegmento();
        this.modalListaFacturas = this.estadosDeCuentaCliente.EstadoDeCuentaXFactura.filter(function (el) { return (el.RAM_COD == e.RAM_COD && el.ASE_COD == e.ASE_COD) });
        this.modalListaFacturas.forEach(a => {
            if (a.PRIMA == null) {
                a.PRIMA = 0;
            }
            if (a.Mas30 == null) {
                a.Mas30 = 0;
            }
            if (a.De0A7 == null) {
                a.De0A7 = 0;
            }
            if (a.De8A15 == null) {
                a.De8A15 = 0;
            }
            if (a.De16A30 == null) {
                a.De16A30 = 0;
            }
            this.modalPrima += a.PRIMA;
            this.modalMas30 += a.Mas30;
            this.modalDe0a7 += a.De0A7;
            this.modalDe8a15 += a.De8A15;
            this.modalDe16a30 += a.De16A30;
            this.modalDias += a.DIAS;
        });
        this.modalPrima = Math.round(this.modalPrima * 100) / 100;
        this.modalMas30 = Math.round(this.modalMas30 * 100) / 100;
        this.modalDe0a7 = Math.round(this.modalDe0a7 * 100) / 100;
        this.modalDe8a15 = Math.round(this.modalDe8a15 * 100) / 100;
        this.modalDe16a30 = Math.round(this.modalDe16a30 * 100) / 100;
        this.modal.open();

        if( this.modalDias>60)
            this.diasBandera=1;
    }

    cerrarTabla(parametro: number) {
        switch (parametro) {
            case 1:
                if (this.patrimonial == false) {
                    this.patrimonial = true;
                } else {
                    this.patrimonial = false;
                    this.fianzasPymes = true;
                    this.vidaAsistencia = true;
                }
                break;
            case 2:
                if (this.fianzasPymes == false) {
                    this.fianzasPymes = true;
                } else {
                    this.patrimonial = true;
                    this.fianzasPymes = false;
                    this.vidaAsistencia = true;
                }
                break;
            case 3:
                if (this.vidaAsistencia == false) {
                    this.vidaAsistencia = true;
                } else {
                    this.patrimonial = true;
                    this.fianzasPymes = true;
                    this.vidaAsistencia = false;
                }
                break;
        }
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/estadoDeCuenta/estado-de-cuenta.component.ts